type StepperProps = {
  currentStep: 1 | 2 | 3
}

// チェックマークアイコン（完了状態用）
const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#9FA6AD" />
    <path
      d="M8.04861 12.3472L5.15278 9.45139L4.16667 10.4306L8.04861 14.3125L16.3819 5.97917L15.4028 5L8.04861 12.3472Z"
      fill="white"
    />
  </svg>
)

// 数字アイコン（アクティブ・未完了状態用）
const NumberIcon = ({ number, isActive }: { number: number; isActive: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill={isActive ? "#16A34A" : "#9FA6AD"} />
    <text x="10" y="14" textAnchor="middle" fill="white" fontSize="10" fontWeight="500">
      {number}
    </text>
  </svg>
)

/**
 * 新規ユーザ登録用ステッパーコンポーネント
 * - 1: メール送信
 * - 2: 受信メール確認
 * - 3: 会員情報登録
 * @param currentStep 現在のステップ（1〜3）
 * @constructor
 */
export const Stepper = ({ currentStep }: StepperProps) => {
  // 引数が範囲外の場合はエラー
  if (currentStep < 1 || currentStep > 3) {
    return null
  }
  const steps = [
    { number: 1, label: "メール送信" },
    { number: 2, label: "受信メール確認" },
    { number: 3, label: "会員情報登録" },
  ]

  const getStepState = (stepNumber: number): "completed" | "active" | "inactive" => {
    if (stepNumber < currentStep) return "completed"
    if (stepNumber === currentStep) return "active"
    return "inactive"
  }

  return (
    <div className="mx-auto flex w-[396px] items-center gap-2 pt-6">
      {steps.map((step, index) => (
        <div key={step.number} className="contents">
          <div className="flex flex-col items-center gap-4">
            {getStepState(step.number) === "completed" ? (
              <CheckIcon />
            ) : (
              <NumberIcon number={step.number} isActive={getStepState(step.number) === "active"} />
            )}
            <span
              className="text-center font-['Roboto'] text-sm font-medium leading-[1.57] tracking-[0.1px] text-[#32383E]"
              style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && <div className="h-[1px] flex-1 bg-gray-300" />}
        </div>
      ))}
    </div>
  )
}
